export default {"src":"/_next/static/media/bg_profile.759ceb78.svg","height":200,"width":215};